export const DESTINATION_ORDER_TYPE = 'destinationOrderType'
